import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
const relatedCourses = [{
  title: "Técnico Electricista",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583410/img/course_electrician_action.png",
  link: "/ElectricalTechnicianPage"
}, {
  title: "Energía Solar",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583410/img/course_solar_action.png",
  link: "/SolarEnergyTechnicianPage"
}, {
  title: "Supervisor Forestal",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583410/img/course_forestry_action.png",
  link: "/ForestSupervisorPage"
}];
export default function CursosRelacionados() {
  return <section id="cursos-relacionados" className="bg-background py-[120px]">
      <div className="container mx-auto px-4 md:px-6">
        <h2 className="mb-16 text-center text-3xl font-bold uppercase tracking-[-0.02em] text-foreground md:text-4xl">
          Cursos Relacionados
        </h2>

        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          {relatedCourses.map((course, i) => <Card key={course.title} data-index={i} className="group relative flex flex-col overflow-hidden rounded-[24px] border-none bg-foreground text-background transition-all duration-300 hover:-translate-y-[10px] hover:shadow-[0_10px_40px_-10px_var(--color-primary)]">
              <div className="relative h-64 w-full shrink-0 overflow-hidden">
                <img src={course.image} alt={`Estudiantes en acción - ${course.title}`} className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                {}
                <div className="absolute inset-0 bg-primary/30 mix-blend-multiply transition-opacity duration-300 group-hover:bg-primary/40" />
              </div>

              <div className="flex flex-1 flex-col justify-between p-2">
                <CardHeader>
                  <CardTitle className="text-2xl font-bold leading-tight text-background">
                    {course.title}
                  </CardTitle>
                </CardHeader>

                <CardContent>
                  <Button variant="link" className="group/btn h-auto p-0 text-base font-semibold text-primary hover:text-primary/80" asChild>
                    <Link to="https://wa.me/59896344395" newTab>
                      WhatsApp
                      <ArrowRight className="ml-2 size-5 transition-transform group-hover/btn:translate-x-1" />
                    </Link>
                  </Button>
                </CardContent>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}